import React, { useEffect, useState } from "react";
import Box from "../../../setupPage/SharedComponents/Box";
import SetupTittle from "../../../setupPage/SharedComponents/SetupTittle";
import { crmGetEvents, crmGetOnline, crmGetSessions } from "../../../../api/crmApi";

const CrmActivity = () => {
  const [online, setOnline] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [events, setEvents] = useState([]);

  const load = async () => {
    const [o, s, e] = await Promise.all([
      crmGetOnline(),
      crmGetSessions(),
      crmGetEvents({ take: 200 }),
    ]);
    setOnline(o);
    setSessions(s);
    setEvents(e);
  };

  useEffect(() => {
    load().catch(() => {});
    const t = setInterval(() => load().catch(() => {}), 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <Box top>
      <SetupTittle text="Staff activity" />
      <p className="text-stone-600 mb-4 max-w-3xl">
        Superadmin view of who is on the system, how long they stayed, and what they last did.
      </p>
      <div className="rounded-2xl border border-green-200 bg-green-50 p-4 mb-5">
        <p className="font-semibold mb-2">Online now</p>
        {online.length === 0 ? (
          <p className="text-sm text-stone-500">Nobody is currently online.</p>
        ) : (
          <ul className="text-sm space-y-1">
            {online.map((s) => (
              <li key={s.id || s.Id}>
                <strong>{s.userName || s.UserName}</strong> · {s.lastScreen || s.LastScreen || "—"} · last seen{" "}
                {new Date(s.lastSeenAt || s.LastSeenAt).toLocaleTimeString()}
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="rounded-2xl border border-stone-200 bg-white p-4 overflow-x-auto">
          <p className="font-semibold mb-2">Sessions</p>
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-left text-stone-500">
                <th className="py-1">User</th>
                <th>Start</th>
                <th>Minutes</th>
                <th>Screen</th>
              </tr>
            </thead>
            <tbody>
              {sessions.slice(0, 50).map((s) => (
                <tr key={s.id || s.Id} className="border-t">
                  <td className="py-1">{s.userName || s.UserName}</td>
                  <td>{new Date(s.startedAt || s.StartedAt).toLocaleString()}</td>
                  <td>{s.minutesOnSystem ?? s.MinutesOnSystem}</td>
                  <td>{s.lastScreen || s.LastScreen}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="rounded-2xl border border-stone-200 bg-white p-4 overflow-x-auto">
          <p className="font-semibold mb-2">Recent actions</p>
          <ul className="text-sm space-y-2">
            {events.slice(0, 40).map((e) => (
              <li key={e.id || e.Id} className="border-b border-stone-100 pb-1">
                <strong>{e.userName || e.UserName}</strong> {e.eventType || e.EventType}{" "}
                {e.detail || e.Detail || e.screen || e.Screen}
                <div className="text-xs text-stone-400">
                  {new Date(e.creationDate || e.CreationDate).toLocaleString()}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Box>
  );
};

export default CrmActivity;
